import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-header-row',
  templateUrl: './header-row.component.html',
  styleUrls: ['./header-row.component.scss'],
})
export class HeaderRowComponent implements OnInit {
  @Input() headers:string[];

  constructor() { }

  ngOnInit() {}

}
